module.exports = __webpack_public_path__ + "img/设备的数字化集成系统.38c1e389.png";